import React from 'react';
export function ResetPasswordTemplate() {
  return <div style={{
    fontFamily: 'Arial, sans-serif',
    maxWidth: '600px',
    margin: '0 auto'
  }} data-id="element-562">
      {/* Header with logo */}
      <div style={{
      textAlign: 'center',
      padding: '32px 0'
    }} data-id="element-563">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hnodgoqduyba7n8dlqxg6c/d4d40573-a6d5-4127-bafb-e288840a0b5f/AISCO_WORKSPACE_MARCA_POSITIVO.svg" alt="Aisco Workspace" style={{
        height: '40px',
        display: 'inline-block'
      }} data-id="element-564" />
      </div>

      {/* Main content */}
      <div style={{
      backgroundColor: '#ffffff',
      padding: '40px 32px'
    }} data-id="element-565">
        <h1 style={{
        fontSize: '24px',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '16px',
        marginTop: '0'
      }} data-id="element-566">
          Reset your password
        </h1>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '24px'
      }} data-id="element-567">
          Hello,
        </p>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '24px'
      }} data-id="element-568">
          We received a request to reset the password for your Aisco Workspace
          account.
        </p>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '32px'
      }} data-id="element-569">
          To create a new password, click the button below:
        </p>

        {/* CTA Button */}
        <div style={{
        textAlign: 'center',
        margin: '32px 0'
      }} data-id="element-570">
          <a href="#" style={{
          display: 'inline-block',
          backgroundColor: '#2563eb',
          color: '#ffffff',
          padding: '14px 32px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: '600'
        }} data-id="element-571">
            Reset password
          </a>
        </div>

        <div style={{
        backgroundColor: '#fef3c7',
        padding: '16px',
        borderRadius: '8px',
        borderLeft: '4px solid #f59e0b',
        marginTop: '32px'
      }} data-id="element-572">
          <p style={{
          fontSize: '14px',
          color: '#92400e',
          lineHeight: '1.6',
          margin: '0'
        }} data-id="element-573">
            <strong data-id="element-574">Important:</strong> This link will expire in 1 hour for
            security reasons.
          </p>
        </div>

        <p style={{
        fontSize: '14px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginTop: '32px',
        marginBottom: '0'
      }} data-id="element-575">
          If you didn't request a password reset, you can safely ignore this
          message. Your current password will remain valid.
        </p>
      </div>

      {/* Footer */}
      <div style={{
      backgroundColor: '#f9fafb',
      padding: '24px 32px',
      borderTop: '1px solid #e5e7eb',
      textAlign: 'center'
    }} data-id="element-576">
        <p style={{
        fontSize: '12px',
        color: '#6b7280',
        lineHeight: '1.5',
        margin: '0'
      }} data-id="element-577">
          Aisco Europe S.A.U • Calle Playa de Riazor 22, 28042
          <br data-id="element-578" />
          Madrid, Spain
        </p>
      </div>
    </div>;
}